// extracted by mini-css-extract-plugin
export var wordContainer = "_mq-0";